(function () {
  function buildToc() {
    var body = document.querySelector('[data-uw-article-body]');
    var toc = document.querySelector('[data-uw-toc]');
    if (!body || !toc) return;
    var headings = body.querySelectorAll('h2');
    if (!headings.length) return;
    var list = toc.querySelector('[data-uw-toc-list]');
    if (!list) return;
    list.textContent = '';
    var frag = document.createDocumentFragment();
    Array.prototype.forEach.call(headings, function (h, i) {
      if (!h.id) h.id = 'section-' + (i + 1);
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      frag.appendChild(li);
    });
    list.appendChild(frag);
    toc.hidden = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildToc);
  } else {
    buildToc();
  }

  // Rebuild when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', buildToc);
})();
